module.exports = __webpack_public_path__ + "img/pr-34.f02a5b18.png";